import { memo } from "react";
import { cn } from "@/lib/utils";
import LexicalContent from "./LexicalContent";
import type { MemoContentProps } from "./types";

const MemoContent = (props: MemoContentProps) => {
  const { className, contentClassName, content, onClick, onDoubleClick } = props;

  // All memos use Lexical format
  return (
    <div
      className={cn("w-full flex flex-col justify-start items-start text-foreground", className)}
      onClick={onClick}
      onDoubleClick={onDoubleClick}
    >
      <LexicalContent content={content} className={contentClassName} />
    </div>
  );
};

export default memo(MemoContent);
